/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { LanguageService } from "src/app/shared/service/language.service";
import { TranslationService } from "src/app/shared/service/translation.service";
import { StoreManagerService } from "src/app/shared/store-manager/services/store-manager.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class FooterComponent implements OnInit {
  public readonly route = inject(Router);
  private readonly _translationService = inject(TranslationService);
  private readonly _langauageService = inject(LanguageService);
  private readonly _storeMagerService = inject(StoreManagerService);

  svgIconFb = "./assets/images/social-icon-fb.svg";
  svgIconTwitter = "./assets/images/social-icon-twitter.svg";
  svgIconInstagram = "./assets/images/social-icon-instagram.svg";
  svgIconYoutube = "./assets/images/social-icon-youtube.svg";
  svgIconGplus = "./assets/images/social-icon-gplus.svg";
  svgIconArrow = "./assets/images/arrow.svg";

  window: any;
  selectedLanguage: string;
  isLocation: boolean = false;
  currentYear: number = new Date().getFullYear();
  allSupportedLangCodes: any[];
  public isLanguageSelctionEnabled: boolean = false;
  public showLanguageSelectionModal: boolean = false;
  public userLanguageForDisplay: string = "English";
  public translationData: any;

  constructor() {
    this.isLanguageSelctionEnabled =
      this._translationService.featureFlags?.locations.enableLanguageSelection;
    const selectedLanguage =
      this._storeMagerService.getUserSelectedLanguageFromStore();
    this.allSupportedLangCodes =
      this._translationService.getSupportedLanguageByCode();
    this.userLanguageForDisplay = this.getUserSelectedLanguage();
    this.selectedLanguage =
      selectedLanguage ??
      this.allSupportedLangCodes.find((lang) => lang.includes("en")) ??
      "en-GB";
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.route.events.subscribe((events) => {
      if (events instanceof NavigationEnd) {
        this.isLocation = events.url.includes("gmap");
      }
    });
  }

  switchLanguage(language: string) {
    this._storeMagerService.setUserLanguageToStore(language);
    const fullURL = window.location.href.split("/");
    fullURL[3] = language;
    window.location.href = fullURL.join("/");
  }

  public getUserSelectedLanguage(): string {
    const selectedLanguage =
      this._storeMagerService.getUserSelectedLanguageFromStore();
    const supportedLangList =
      this._translationService.supportedLanguagesForDisplay;
    const langName = supportedLangList.find(
      (lang: any) => lang.localeCode === selectedLanguage,
    );
    return langName?.localeDescription?.split("(")[0] ?? "English";
  }

  public openLanguageSelection() {
    this._langauageService.showLanguageModalState.set(true);
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
